import { toCapitalisedCamelCase } from 'Data/format'

export function getTitle(connection_name) {
  switch (connection_name) {
    case 'ids': {
      return 'Invisalign® Doctor Site Automations'
    }
    case 'itero': {
      return 'iTero™ Automations'
    }
    default: {
      return `${toCapitalisedCamelCase(connection_name)} Automations`
    }
  }
}
